export default __webpack_public_path__ + "static/media/fastener-placement-rounded-rectangle-1-break.5813bf94.webp";